// src/components/LangSwitch.jsx
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const SUPPORTED = ["en", "ro"];

export default function LangSwitch() {
  const { i18n } = useTranslation();
  const { lng } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const current = (lng || i18n.resolvedLanguage || "en").slice(0, 2);
  const is = (code) => current.startsWith(code);

  const switchTo = (code) => () => {
    // Swap the leading /:lng segment, keep the rest of the path + search + hash
    const parts = location.pathname.split("/");
    if (SUPPORTED.includes(parts[1])) {
      parts[1] = code;
    } else {
      parts.splice(1, 0, code);
    }
    const newPath = parts.join("/") || `/${code}`;
    navigate(`${newPath}${location.search}${location.hash}`);
  };

  return (
    <div className="flex items-center gap-1 rounded-xl border border-slate-300 px-1 py-1 text-xs bg-white/70">
      <button
        onClick={switchTo("en")}
        className={`px-2 py-1 rounded-lg ${is("en") ? "bg-slate-200 font-semibold" : "hover:bg-slate-100"}`}
        aria-pressed={is("en")}
      >
        EN
      </button>
      <button
        onClick={switchTo("ro")}
        className={`px-2 py-1 rounded-lg ${is("ro") ? "bg-slate-200 font-semibold" : "hover:bg-slate-100"}`}
        aria-pressed={is("ro")}
      >
        RO
      </button>
    </div>
  );
}
